import { TranslationCatalog } from './translations.types';

export const LANDING_TRANSLATIONS: TranslationCatalog = {
  es: {
    'landing.nav.home': 'Inicio',
    'landing.nav.companies': 'Para Empresas',
    'landing.nav.candidates': 'Para Candidatos',
    'landing.nav.pricing': 'Planes',
    'landing.nav.contact': 'Contacto',
    'landing.nav.login': 'Iniciar sesi\u00f3n',
    'landing.nav.register': 'Reg\u00edstrate',

    'landing.hero.stats.time': 'Menos tiempo de contrataci\u00f3n',
    'landing.hero.stats.companies': 'Empresas que conf\u00edan en nosotros',
    'landing.hero.stats.satisfaction': 'Satisfacci\u00f3n de candidatos',
    'landing.hero.companies.headline':
      'WeMatch:<br><span>inteligencia para conectar<br>talento con oportunidades.</span>',
    'landing.hero.companies.body':
      'WeMatch utiliza inteligencia artificial para conectar empresas con el talento adecuado, de forma m\u00e1s r\u00e1pida, justa y confiable.',
    'landing.hero.companies.primary': 'Prueba gratuita de 7 d\u00edas',
    'landing.hero.companies.secondary': 'Reg\u00edstrate gratis',
    'landing.hero.companies.imageAlt': 'Hero de empresas de WeMatch',
    'landing.hero.companies.floatingTop': 'M\u00e1s de 10.000 candidatos',
    'landing.hero.companies.floatingBottomTitle': 'Sube tu CV',
    'landing.hero.companies.floatingBottomText': 'Solo toma unos segundos',
    'landing.hero.candidates.headline':
      'Encuentra<br>oportunidades reales,<br><span>sin sesgos ni<br>complicaciones.</span>',
    'landing.hero.candidates.body':
      'Crea tu perfil, valida tu identidad y post\u00falate en minutos. Nuestra IA conecta tu talento con las mejores oportunidades, de forma justa y transparente.',
    'landing.hero.candidates.primary': 'Crear perfil gratis',
    'landing.hero.candidates.secondary': 'Explorar vacantes',
    'landing.hero.candidates.imageAlt': 'Hero de candidatos de WeMatch',
    'landing.hero.candidates.floatingTop': '3 nuevas vacantes para ti',
    'landing.hero.candidates.floatingBottomTitle': 'Match encontrado',
    'landing.hero.candidates.floatingBottomText': 'Solo toma unos segundos',

    'landing.problem.title': 'El reclutamiento tradicional es lento, costoso e ineficiente',
    'landing.problem.subtitle':
      'Las empresas pierden tiempo valioso revisando manualmente cientos de CV, realizando entrevistas que no aportan valor y lidiando con candidatos no calificados.',
    'landing.problem.imageAlt': 'Imagen de la secci\u00f3n de problema',
    'landing.problem.stat1.suffix': ' d\u00edas',
    'landing.problem.stat1.title': 'Promedio',
    'landing.problem.stat1.text':
      'Tiempo para contratar con m\u00e9todos tradicionales, generando p\u00e9rdidas de productividad.',
    'landing.problem.stat2.prefix': '+ ',
    'landing.problem.stat2.suffix': '',
    'landing.problem.stat2.title': 'Aplicaciones',
    'landing.problem.stat2.text':
      'Por vacante que deben revisarse manualmente, consumiendo horas de RR. HH.',
    'landing.problem.stat3.suffix': '%',
    'landing.problem.stat3.prefix': 'Hasta ',
    'landing.problem.stat3.title': 'de fraude',
    'landing.problem.stat3.text':
      'De informaci\u00f3n en CV, desde habilidades infladas hasta identidades falsas.',

    'landing.solution.title': 'WeMatch automatiza todo el proceso con inteligencia artificial',
    'landing.solution.subtitle':
      'Utilizamos inteligencia artificial para reducir el tiempo de contrataci\u00f3n en 70 %, validar autom\u00e1ticamente candidatos y garantizar procesos transparentes y justos.',
    'landing.solution.companies.title': 'Para Empresas',
    'landing.solution.companies.item1': 'Filtrado autom\u00e1tico de CV con hasta 99 % de precisi\u00f3n.',
    'landing.solution.companies.item2': 'Evaluaci\u00f3n t\u00e9cnica automatizada con inteligencia artificial.',
    'landing.solution.companies.item3': 'Validaci\u00f3n de identidad y experiencia real.',
    'landing.solution.companies.item4': 'Reportes de match basados en soft skills.',
    'landing.solution.companies.primary': 'Optimizar mi reclutamiento',
    'landing.solution.candidates.title': 'Para Candidatos',
    'landing.solution.candidates.item1': 'Sube tu perfil una vez y aplica a cientos de vacantes.',
    'landing.solution.candidates.item2': 'Feedback instant\u00e1neo sobre tu CV y habilidades.',
    'landing.solution.candidates.item3':
      'IA que resalta tus fortalezas reales ante reclutadores.',
    'landing.solution.candidates.item4': 'Rutas de aprendizaje para cerrar brechas t\u00e9cnicas.',
    'landing.solution.candidates.primary': 'Impulsar mi carrera',
    'landing.solution.candidates.secondary': 'Explorar vacantes',

    'landing.testimonials.title':
      'Lo que dicen las empresas y candidatos que ya usan WeMatch',
    'landing.testimonials.previous': 'Anterior',
    'landing.testimonials.next': 'Siguiente',
    'landing.testimonials.pagination': 'Paginaci\u00f3n de testimonios',
    'landing.testimonials.goToGroup': 'Ir al grupo {group}',
    'landing.testimonials.1.quote':
      '"WeMatch cambi\u00f3 las reglas del juego. Pasamos de 2 meses para contratar a un Dev Senior a solo 12 d\u00edas. La precisi\u00f3n de la IA es impresionante."',
    'landing.testimonials.1.name': 'Elena Rivas',
    'landing.testimonials.1.role': 'Head of Talent, FinTech Solutions',
    'landing.testimonials.2.quote':
      '"Lo mejor es la dr\u00e1stica reducci\u00f3n del fraude. Ahora sabemos exactamente qu\u00e9 sabe hacer el candidato antes de la primera llamada humana."',
    'landing.testimonials.2.name': 'Marcos Ben\u00edtez',
    'landing.testimonials.2.role': 'CTO, CloudScale Systems',
    'landing.testimonials.3.quote':
      '"La integraci\u00f3n fue transparente. Mi equipo de reclutamiento ahora se enfoca en la cultura, no en descartar CV irrelevantes."',
    'landing.testimonials.3.name': 'Sara Velasco',
    'landing.testimonials.3.role': 'Lead Recruiter, Global Logix',
    'landing.testimonials.4.quote':
      '"La precisi\u00f3n del filtro inicial nos devolvi\u00f3 tiempo real. Ahora cada entrevista tiene sentido y no gastamos energ\u00eda en perfiles equivocados."',
    'landing.testimonials.4.name': 'Camila Duarte',
    'landing.testimonials.4.role': 'Talent Lead, Nova Growth',
    'landing.testimonials.5.quote':
      '"Antes revis\u00e1bamos hojas de vida durante horas. Con WeMatch pasamos a enfocarnos en la decisi\u00f3n, no en la administraci\u00f3n."',
    'landing.testimonials.5.name': 'Jorge Mar\u00edn',
    'landing.testimonials.5.role': 'People Director, Vector Labs',
    'landing.testimonials.6.quote':
      '"Sub\u00ed mi perfil una sola vez y en menos de una semana ya ten\u00eda matches mucho m\u00e1s alineados con mi experiencia real."',
    'landing.testimonials.6.name': 'Andrea Pardo',
    'landing.testimonials.6.role': 'Product Designer Candidate',
    'landing.testimonials.7.quote':
      '"El feedback inmediato hizo que mejorara mi perfil desde el primer intento. Se siente como aplicar con mucha m\u00e1s claridad."',
    'landing.testimonials.7.name': 'Daniel Ocampo',
    'landing.testimonials.7.role': 'Backend Candidate',
    'landing.testimonials.8.quote':
      '"La velocidad de cierre mejor\u00f3 sin sacrificar calidad. Pudimos contratar m\u00e1s r\u00e1pido y con mucha menos fricci\u00f3n en el proceso."',
    'landing.testimonials.8.name': 'Laura Quintana',
    'landing.testimonials.8.role': 'COO, Blue Orbit',
    'landing.testimonials.9.quote':
      '"Lo m\u00e1s valioso fue la confianza. El sistema detect\u00f3 inconsistencias que en un proceso tradicional habr\u00edan pasado desapercibidas."',
    'landing.testimonials.9.name': 'Felipe Suaza',
    'landing.testimonials.9.role': 'Recruitment Manager, Altitude Tech',
    'landing.testimonials.10.quote':
      '"Sent\u00ed que por fin mi perfil estaba compitiendo por capacidades reales y no solo por palabras clave en una hoja de vida."',
    'landing.testimonials.10.name': 'Paula R\u00edos',
    'landing.testimonials.10.role': 'Frontend Candidate',

    'landing.demo.title': 'Conoce la plataforma en acci\u00f3n',
    'landing.demo.tabLabel': 'Tipo de demo',
    'landing.demo.tabCompanies': 'Para Empresas',
    'landing.demo.tabCandidates': 'Para Candidatos',
    'landing.demo.play': 'Reproducir demo en video',
    'landing.demo.pause': 'Pausar video',
    'landing.demo.restart': 'Reiniciar video',
    'landing.demo.mute': 'Silenciar video',
    'landing.demo.unmute': 'Activar sonido del video',
    'landing.demo.fullscreen': 'Ver en pantalla completa',
    'landing.demo.exitFullscreen': 'Salir de pantalla completa',
    'landing.demo.progress': 'Progreso del video',
    'landing.demo.primary': 'Prueba gratuita de 7 d\u00edas',
    'landing.demo.secondary': 'Reg\u00edstrate gratis',
    'landing.demo.close': 'Cerrar video',
    'landing.demo.fallback': 'Tu navegador no soporta video HTML5.',

    'landing.explore.breadcrumb': 'Miga de pan',
    'landing.explore.current': 'Explorar vacantes',
    'landing.explore.searchLabel': 'Buscar vacantes',
    'landing.explore.searchPlaceholder': 'Buscar por palabra clave',
    'landing.explore.filter': 'Filtrar',
    'landing.explore.perPage': '{count} por p\u00e1gina',
    'landing.explore.clearFilters': 'Limpiar filtros',
    'landing.explore.resetFilters': 'Restablecer filtros',
    'landing.explore.results.none': 'No encontramos vacantes con esos filtros.',
    'landing.explore.results.one': '1 vacante disponible',
    'landing.explore.results.many': '{count} vacantes disponibles',
    'landing.explore.empty.title': 'No encontramos ofertas con esos criterios',
    'landing.explore.empty.body': 'Ajusta los filtros o limpia la b\u00fasqueda para ver m\u00e1s resultados.',
    'landing.explore.filters.eyebrow': 'Explorar vacantes',
    'landing.explore.filters.title': 'Filtrar empleos',
    'landing.explore.filters.close': 'Cerrar filtros',
    'landing.explore.filters.perPageLabel': 'Cantidad por p\u00e1gina',
    'landing.explore.filters.area': '\u00c1rea / categor\u00eda',
    'landing.explore.filters.contractType': 'Tipo de contrato',
    'landing.explore.filters.city': 'Ciudad',
    'landing.explore.filters.experience': 'Experiencia',
    'landing.explore.filters.salary': 'Salario',
    'landing.explore.filters.selectOption': 'Selecciona una opci\u00f3n',
    'landing.explore.filters.clear': 'Limpiar',
    'landing.explore.filters.find': 'Encontrar empleos',
    'landing.explore.card.highDemand': 'Alta demanda',
    'landing.explore.card.published': 'Publicado',
    'landing.explore.card.applicants': 'aplicantes',
    'landing.explore.detail.close': 'Cerrar detalle',
    'landing.explore.detail.share': 'Compartir vacante',
    'landing.explore.detail.apply': 'Aplicar ahora',
    'landing.explore.detail.description': 'Descripci\u00f3n del cargo',
    'landing.explore.detail.highDemand': 'Alta demanda',
    'landing.explore.detail.requirements': 'Requisitos',
    'landing.explore.detail.stack': 'Stack y habilidades',
    'landing.explore.detail.perks': 'Beneficios',
    'landing.explore.detail.unlockTitle': 'Post\u00falate y desbloquea el detalle completo',
    'landing.explore.detail.unlockBody':
      'Reg\u00edstrate en WeMatch para ver toda la informaci\u00f3n de la oferta y aplicar ahora.',
    'landing.explore.detail.unlockAction': 'Post\u00falate ahora',
    'landing.preferences.interface': 'Preferencias de interfaz',
    'landing.preferences.language': 'Idioma',

    'landing.footer.tagline':
      'Conectando la inteligencia con las oportunidades. Redefiniendo el est\u00e1ndar de una contrataci\u00f3n justa y eficiente.',
    'landing.footer.followUs': 'S\u00edguenos en',
    'landing.footer.product': 'Producto',
    'landing.footer.companies': 'Para Empresas',
    'landing.footer.candidates': 'Para Candidatos',
    'landing.footer.howItWorks': 'C\u00f3mo funciona',
    'landing.footer.pricing': 'Planes',
    'landing.footer.company': 'Compa\u00f1\u00eda',
    'landing.footer.about': 'Sobre nosotros',
    'landing.footer.support': 'Contactar soporte',
    'landing.footer.legal': 'Legal',
    'landing.footer.privacy': 'Pol\u00edtica de Privacidad',
    'landing.footer.terms': 'T\u00e9rminos y Condiciones',
    'landing.footer.rights': 'Todos los derechos reservados.',

    'landing.companies.hero.eyebrow': 'Para empresas',
    'landing.companies.hero.title':
      'Encuentra el <span>talento perfecto</span> sin sesgos ni demoras.',
    'landing.companies.hero.body':
      'WeMatch utiliza Inteligencia Artificial avanzada para conectar a las empresas con los candidatos ideales, optimizando cada fase del proceso de selecci\u00f3n.',
    'landing.companies.hero.primary': 'Prueba gratuita de 7 d\u00edas',
    'landing.companies.hero.secondary': 'Reg\u00edstrate gratis',
    'landing.companies.hero.badgeTop': 'An\u00e1lisis inteligente activo',
    'landing.companies.hero.badgeBottom': 'Validaci\u00f3n en segundos',
    'landing.companies.hero.imageAlt': 'Vista principal para empresas',
    'landing.companies.stats.1': 'Tiempo promedio para contratar',
    'landing.companies.stats.2': 'Candidatos calificados por vacante',
    'landing.companies.stats.3.value': 'Zero Bias',
    'landing.companies.stats.3': 'Filtro con evaluaci\u00f3n justa',
    'landing.companies.stats.4.value': 'Global',
    'landing.companies.stats.4': 'Cobertura para talento remoto',
    'landing.companies.results.title': 'Resultados que transforman tu equipo',
    'landing.companies.results.body':
      'Nuestra tecnolog\u00eda no solo acelera el proceso, sino que garantiza la calidad de cada contrataci\u00f3n.',
    'landing.companies.results.card1.label': 'Eficiencia m\u00e1xima',
    'landing.companies.results.card1.title': 'Reducci\u00f3n del tiempo de contrataci\u00f3n a la mitad.',
    'landing.companies.results.card1.metric': 'D\u00edas',
    'landing.companies.results.card1.caption': 'Promedio por vacante',
    'landing.companies.results.card1.imageAlt': 'Reloj de arena midiendo el tiempo de contrataci\u00f3n',
    'landing.companies.results.card2.body': 'Candidatos calificados por cada vacante publicada.',
    'landing.companies.results.card3.title': 'Zero Bias AI',
    'landing.companies.results.card3.body':
      'Algoritmos dise\u00f1ados para eliminar sesgos inconscientes en el cribado inicial.',
    'landing.companies.results.card4.title': 'Talento Global',
    'landing.companies.results.card4.body':
      'Accede a una base de datos de millones de profesionales listos para nuevos retos.',
    'landing.companies.results.card4.imageAlt': 'Equipo de trabajo colaborando',
    'landing.companies.steps.1.title': 'Publica tu vacante',
    'landing.companies.steps.1.body':
      'Crea la oferta con objetivos, seniority y stack. Nosotros estructuramos la evaluaci\u00f3n base.',
    'landing.companies.steps.2.title': 'Evaluaci\u00f3n automatizada',
    'landing.companies.steps.2.body':
      'La IA revisa trayectoria, compatibilidad y se\u00f1ales de riesgo antes de la primera llamada.',
    'landing.companies.steps.3.title': 'Validaci\u00f3n de identidad',
    'landing.companies.steps.3.body':
      'Verificamos informaci\u00f3n clave para reducir fraude documental y mejorar la confianza del equipo.',
    'landing.companies.steps.4.title': 'Contrata con confianza',
    'landing.companies.steps.4.body':
      'Recibe shortlist, an\u00e1lisis comparativo y evidencia centralizada para decidir m\u00e1s r\u00e1pido.',
    'landing.companies.process.title': '\u00bfC\u00f3mo funciona WeMatch?',
    'landing.companies.process.body':
      'Un flujo guiado para atraer, automatizar y validar candidatos sin perder visibilidad del proceso.',
    'landing.companies.process.cta': 'Ver planes',
    'landing.companies.process.panelTitle': 'An\u00e1lisis de perfil #4821',
    'landing.companies.process.panelBadge': 'Listo para revisar',
    'landing.companies.process.metric1': 'Compatibilidad t\u00e9cnica',
    'landing.companies.process.metric2': 'Se\u00f1ales de liderazgo',
    'landing.companies.process.metric3': 'Ajuste cultural',
    'landing.companies.process.chip1': 'C\u00f3digo validado',
    'landing.companies.process.chip2': 'Bias free',
    'landing.companies.process.chip3': 'Proceso seguro',
    'landing.companies.cta.title': '\u00bfListo para transformar tu equipo de talento?',
    'landing.companies.cta.body':
      'Empieza hoy mismo y descubre por qu\u00e9 las empresas l\u00edderes conf\u00edan en WeMatch para escalar sus equipos.',
    'landing.companies.cta.button': 'Solicitar prueba gratuita de 7 d\u00edas',
    'landing.companies.cta.note': 'Sin costos ocultos. Sin periodos m\u00ednimos de permanencia.',

    'landing.candidates.hero.eyebrow': 'Para candidatos',
    'landing.candidates.hero.title':
      'Tu pr\u00f3xima <span>gran oportunidad</span> te est\u00e1 buscando.',
    'landing.candidates.hero.body':
      'Encuentra vacantes reales que se ajustan a tu perfil sin complicaciones. Potencia tu CV con nuestra IA y destaca tus fortalezas autom\u00e1ticamente.',
    'landing.candidates.hero.primary': 'Crea tu perfil gratis',
    'landing.candidates.hero.secondary': 'Explorar vacantes',
    'landing.candidates.hero.search': 'B\u00fasqueda de empleo...',
    'landing.candidates.hero.imageAlt': 'Vista principal para candidatos',
    'landing.candidates.hero.cardLabel': 'Compatibilidad destacada',
    'landing.candidates.hero.cardTitle': 'Tu perfil est\u00e1 casi listo para destacar',
    'landing.candidates.hero.cardBody':
      'Fortalezas, validaci\u00f3n y claridad narrativa alineadas para acelerar tu siguiente paso.',
    'landing.candidates.hero.metric1': 'Match con producto',
    'landing.candidates.hero.metric2': 'Feedback instant\u00e1neo',
    'landing.candidates.stats.1': 'Tiempo promedio de postulaci\u00f3n',
    'landing.candidates.stats.2': 'Proceso transparente y justo',
    'landing.candidates.stats.3': 'Acceso a tu perfil y aplicaciones',
    'landing.candidates.stats.4': 'Costo para candidatos',
    'landing.candidates.tools.title': 'Herramientas dise\u00f1adas para tu \u00e9xito',
    'landing.candidates.tools.body':
      'Nuestra tecnolog\u00eda trabaja para que t\u00fa solo te preocupes por la entrevista.',
    'landing.candidates.tools.card1.title': 'Instant CV Feedback',
    'landing.candidates.tools.card1.body':
      'Sube tu CV y recibe sugerencias inmediatas basadas en IA para optimizarlo seg\u00fan las tendencias actuales del mercado tecnol\u00f3gico.',
    'landing.candidates.tools.card1.suggestionLabel': 'IA Suggestion',
    'landing.candidates.tools.card1.suggestion':
      '"Highlight your React project architecture experience..."',
    'landing.candidates.tools.card2.title': 'AI-Highlighted Strengths',
    'landing.candidates.tools.card2.body':
      'Analizamos tus logros y destacamos autom\u00e1ticamente tus habilidades m\u00e1s valiosas para los reclutadores.',
    'landing.candidates.tools.card2.item1': 'Leadership in Agile Teams',
    'landing.candidates.tools.card2.item2': 'Microservices Architecture',
    'landing.candidates.tools.card2.signal1': 'Claridad del perfil',
    'landing.candidates.tools.card2.signal2': 'Relevancia para vacantes',
    'landing.candidates.tools.card2.signal3': 'Potencial de entrevista',
    'landing.candidates.tools.card3.title': 'Alertas Inteligentes',
    'landing.candidates.tools.card3.body':
      'Recibe notificaciones solo cuando una vacante sea un "Perfect Match" con tus expectativas salariales y de carrera.',
    'landing.candidates.tools.card3.badge': 'Vacantes activas',
    'landing.candidates.tools.card3.alert1.title': 'Frontend Angular Senior',
    'landing.candidates.tools.card3.alert1.meta': 'Remoto · Bogot\u00e1 / LATAM',
    'landing.candidates.tools.card3.alert1.tag': '94% match',
    'landing.candidates.tools.card3.alert2.title': 'Product Designer',
    'landing.candidates.tools.card3.alert2.meta': 'H\u00edbrido · Medell\u00edn',
    'landing.candidates.tools.card3.alert2.tag': 'Nuevo',
    'landing.candidates.tools.card3.alert3.title': 'QA Automation Engineer',
    'landing.candidates.tools.card3.alert3.meta': 'Remoto · Full time',
    'landing.candidates.tools.card3.alert3.tag': 'Compatible',
    'landing.candidates.tools.card4.title': 'Preparaci\u00f3n para Entrevistas',
    'landing.candidates.tools.card4.body':
      'Practica con nuestro simulador de IA que te har\u00e1 las preguntas m\u00e1s probables para el puesto espec\u00edfico al que aplicas.',
    'landing.candidates.tools.card4.imageAlt': 'Simulador de video entrevista',
    'landing.candidates.tools.card4.screenLabel': 'Simulador de Video Entrevista',
    'landing.candidates.tools.card4.point1': 'Preguntas frecuentes por rol',
    'landing.candidates.tools.card4.point2': 'Respuesta sugerida con estructura',
    'landing.candidates.tools.card4.point3': 'Confianza antes de cada llamada',
    'landing.candidates.tools.card4.badge': 'Modo entrevista',
    'landing.candidates.process.title': '\u00bfC\u00f3mo funciona WeMatch?',
    'landing.candidates.process.body':
      'Cuatro pasos sencillos para activar tu perfil, descubrir oportunidades y postularte con confianza.',
    'landing.candidates.steps.1.title': 'Crea tu perfil',
    'landing.candidates.steps.1.body':
      'Importa tu hoja de vida y completa informaci\u00f3n clave en minutos.',
    'landing.candidates.steps.2.title': 'Descubre oportunidades',
    'landing.candidates.steps.2.body':
      'Explora vacantes con contexto y filtros pensados para decisiones m\u00e1s r\u00e1pidas.',
    'landing.candidates.steps.3.title': 'Post\u00falate f\u00e1cilmente',
    'landing.candidates.steps.3.body':
      'Un solo perfil te permite aplicar de forma consistente y ordenada.',
    'landing.candidates.steps.4.title': 'Recibe feedback',
    'landing.candidates.steps.4.body':
      'Conoce mejor tus fortalezas, brechas y siguientes pasos recomendados.',
    'landing.candidates.process.panelLabel': 'Panel de avance',
    'landing.candidates.process.panelTitle': 'Tu perfil est\u00e1 casi listo para postular',
    'landing.candidates.process.panelBody':
      'Activa peque\u00f1os ajustes y empieza a aparecer con mejor contexto frente a equipos reales.',
    'landing.candidates.process.nextLabel': 'Siguiente mejor acci\u00f3n',
    'landing.candidates.process.nextValue': 'Agregar logros medibles a tu experiencia reciente',
    'landing.candidates.process.card1.title': 'Perfil validado',
    'landing.candidates.process.card1.meta': 'Identidad y datos base completos',
    'landing.candidates.process.card2.title': 'Vacantes relevantes',
    'landing.candidates.process.card2.meta': '3 nuevas oportunidades con alto match',
    'landing.candidates.process.card3.title': 'Feedback pendiente',
    'landing.candidates.process.card3.meta': '2 sugerencias para elevar visibilidad',
    'landing.candidates.cta.title': '\u00bfListo para encontrar tu pr\u00f3xima oportunidad?',
    'landing.candidates.cta.body':
      'Crea tu perfil hoy y mantente listo para vacantes que encajan de verdad con tu experiencia.',
    'landing.candidates.cta.button': 'Crea tu perfil gratis',
    'landing.candidates.cta.note': 'Tarda menos de 2 minutos. Sin compromisos.',

    'landing.pricing.eyebrow': 'Planes',
    'landing.pricing.title': 'Planes dise\u00f1ados para crecer con mejor criterio',
    'landing.pricing.body':
      'Empieza gratis y sube de plan solo cuando necesites m\u00e1s profundidad, m\u00e1s datos o m\u00e1s inteligencia artificial. Sin letra peque\u00f1a.',
    'landing.pricing.tabLabel': 'Tipo de planes',
    'landing.pricing.companies.tab': 'Para Empresas',
    'landing.pricing.candidates.tab': 'Para Candidatos',
    'landing.pricing.companies.summary.label': 'Modelo simple para equipos de talento',
    'landing.pricing.companies.summary.title': 'Empieza gratis. Escala cuando tu equipo lo necesite.',
    'landing.pricing.companies.summary.body':
      'Publica vacantes gratis desde el primer d\u00eda. Sube de plan solo cuando quieras acceso a hojas de vida, resultados de evaluaci\u00f3n e inteligencia artificial avanzada.',
    'landing.pricing.companies.summary.chip1': 'Sin cobro por reclutadores internos',
    'landing.pricing.companies.summary.chip2': 'Empieza gratis, escala cuando quieras',
    'landing.pricing.companies.summary.chip3': 'IA avanzada disponible desde Pro',
    'landing.pricing.companies.summary.stat1.value': '$ 0 - $ 399',
    'landing.pricing.companies.summary.stat1.label': 'rango de inversi\u00f3n mensual seg\u00fan el plan',
    'landing.pricing.companies.summary.stat2.value': '1 equipo',
    'landing.pricing.companies.summary.stat2.label': 'colaborando sin restringir los accesos internos del equipo',
    'landing.pricing.companies.plan1.badge': 'Gratis',
    'landing.pricing.companies.plan1.name': 'Free',
    'landing.pricing.companies.plan1.description': 'Publica vacantes y empieza a recibir candidatos calificados, sin costo y sin letra peque\u00f1a.',
    'landing.pricing.companies.plan1.price': '$ 0',
    'landing.pricing.companies.plan1.cycle': '/ mes',
    'landing.pricing.companies.plan1.metric': 'La puerta de entrada para reclutar con IA: vacantes activas, shortlist inteligente y seguimiento b\u00e1sico de cada proceso.',
    'landing.pricing.companies.plan1.helper': 'Ideal si est\u00e1s publicando tus primeras vacantes y quieres probar WeMatch sin compromiso.',
    'landing.pricing.companies.plan1.ideal': 'Empieza a reclutar con IA',
    'landing.pricing.companies.plan1.feature1': 'Publicaci\u00f3n ilimitada de vacantes',
    'landing.pricing.companies.plan1.feature2': 'Acceso al pool de candidatos activos',
    'landing.pricing.companies.plan1.feature3': 'Shortlist inteligente con ranking inicial',
    'landing.pricing.companies.plan1.feature4': 'Panel de seguimiento de postulaciones',
    'landing.pricing.companies.plan1.stat1.value': '3',
    'landing.pricing.companies.plan1.stat1.label': 'vacantes activas simult\u00e1neas',
    'landing.pricing.companies.plan1.stat2.value': 'Ilimitadas',
    'landing.pricing.companies.plan1.stat2.label': 'vacantes que puedes publicar',
    'landing.pricing.companies.plan1.cta': 'Comenzar gratis',
    'landing.pricing.companies.plan2.badge': 'Recomendado',
    'landing.pricing.companies.plan2.name': 'Premium',
    'landing.pricing.companies.plan2.description': 'Todo lo de Free, m\u00e1s acceso completo a hojas de vida y resultados de evaluaci\u00f3n para decidir con datos reales.',
    'landing.pricing.companies.plan2.price': '$ 149',
    'landing.pricing.companies.plan2.cycle': '/ mes',
    'landing.pricing.companies.plan2.metric': 'Profundiza en cada candidato: curr\u00edculums completos, resultados de pruebas y comparativas para filtrar con criterio, no con intuici\u00f3n.',
    'landing.pricing.companies.plan2.helper': 'Perfecto para equipos que ya filtran activamente y necesitan ver m\u00e1s all\u00e1 del perfil b\u00e1sico.',
    'landing.pricing.companies.plan2.ideal': 'Reclutamiento basado en datos',
    'landing.pricing.companies.plan2.feature1': 'Todo lo incluido en Free',
    'landing.pricing.companies.plan2.feature2': 'Acceso completo a hojas de vida y perfiles de candidatos',
    'landing.pricing.companies.plan2.feature3': 'Resultados detallados de evaluaciones y pruebas t\u00e9cnicas',
    'landing.pricing.companies.plan2.feature4': 'Anal\u00edtica comparativa entre candidatos',
    'landing.pricing.companies.plan2.feature5': 'Verificaci\u00f3n de identidad y se\u00f1ales antifraude',
    'landing.pricing.companies.plan2.stat1.value': '10',
    'landing.pricing.companies.plan2.stat1.label': 'vacantes activas simult\u00e1neas',
    'landing.pricing.companies.plan2.stat2.value': '100%',
    'landing.pricing.companies.plan2.stat2.label': 'acceso a hojas de vida y resultados',
    'landing.pricing.companies.plan2.cta': 'Elegir Premium',
    'landing.pricing.companies.plan3.badge': 'IA Avanzada',
    'landing.pricing.companies.plan3.name': 'Pro',
    'landing.pricing.companies.plan3.description': 'Todo lo de Free y Premium, m\u00e1s inteligencia artificial de punta a punta para automatizar tu reclutamiento por completo.',
    'landing.pricing.companies.plan3.price': '$ 399',
    'landing.pricing.companies.plan3.cycle': '/ mes',
    'landing.pricing.companies.plan3.metric': 'La IA hace el trabajo pesado: rankea candidatos, detecta sesgos y automatiza cada etapa para que tu equipo se enfoque solo en decidir.',
    'landing.pricing.companies.plan3.helper': 'Pensado para equipos que quieren escalar contrataciones sin escalar el esfuerzo manual.',
    'landing.pricing.companies.plan3.ideal': 'Automatizaci\u00f3n total del reclutamiento',
    'landing.pricing.companies.plan3.feature1': 'Todo lo incluido en Premium',
    'landing.pricing.companies.plan3.feature2': 'Matching por IA con ranking autom\u00e1tico de candidatos',
    'landing.pricing.companies.plan3.feature3': 'Entrevistas simuladas y evaluadas por IA',
    'landing.pricing.companies.plan3.feature4': 'Detecci\u00f3n autom\u00e1tica de sesgos en cada etapa del proceso',
    'landing.pricing.companies.plan3.feature5': 'Automatizaciones de comunicaci\u00f3n (recordatorios, seguimientos, respuestas)',
    'landing.pricing.companies.plan3.feature6': 'Soporte prioritario y onboarding dedicado',
    'landing.pricing.companies.plan3.stat1.value': 'Ilimitadas',
    'landing.pricing.companies.plan3.stat1.label': 'vacantes activas simult\u00e1neas',
    'landing.pricing.companies.plan3.stat2.value': 'IA',
    'landing.pricing.companies.plan3.stat2.label': 'en cada etapa del proceso',
    'landing.pricing.companies.plan3.cta': 'Solicitar demo',
    'landing.pricing.candidates.summary.label': 'Modelo para profesionales',
    'landing.pricing.candidates.summary.title': 'Empieza gratis y activa m\u00e1s impulso solo cuando necesites acelerar visibilidad',
    'landing.pricing.candidates.summary.body':
      'La base debe ser accesible para todos. Si quieres m\u00e1s feedback, preparaci\u00f3n y prioridad frente a vacantes, puedes subir de nivel sin complicarte.',
    'landing.pricing.candidates.summary.chip1': 'Perfil gratuito para comenzar',
    'landing.pricing.candidates.summary.chip2': 'Mejoras de visibilidad opcionales',
    'landing.pricing.candidates.summary.chip3': 'Enfoque real en entrevistas y feedback',
    'landing.pricing.candidates.summary.stat1.value': '$ 0 - $ 9',
    'landing.pricing.candidates.summary.stat1.label': 'rango de inversi\u00f3n mensual sugerido',
    'landing.pricing.candidates.summary.stat2.value': '24/7',
    'landing.pricing.candidates.summary.stat2.label': 'acceso a perfil, alertas y seguimiento',
    'landing.pricing.candidates.plan1.badge': 'Gratis',
    'landing.pricing.candidates.plan1.name': 'Free',
    'landing.pricing.candidates.plan1.description': 'Crea tu perfil, explora vacantes reales y post\u00falate cuantas veces quieras, sin pagar nada.',
    'landing.pricing.candidates.plan1.price': '$ 0',
    'landing.pricing.candidates.plan1.cycle': '/ mes',
    'landing.pricing.candidates.plan1.metric': 'Todo lo esencial para empezar a buscar empleo: perfil visible, postulaciones ilimitadas y alertas de vacantes alineadas contigo.',
    'landing.pricing.candidates.plan1.helper': 'Ideal si est\u00e1s empezando tu b\u00fasqueda o quieres validar oportunidades sin fricci\u00f3n.',
    'landing.pricing.candidates.plan1.ideal': 'Empieza a postularte hoy mismo',
    'landing.pricing.candidates.plan1.feature1': 'Perfil profesional visible para empresas',
    'landing.pricing.candidates.plan1.feature2': 'Postulaciones ilimitadas a vacantes',
    'landing.pricing.candidates.plan1.feature3': 'Alertas de vacantes alineadas con tu perfil',
    'landing.pricing.candidates.plan1.feature4': 'Seguimiento del estado de tus postulaciones',
    'landing.pricing.candidates.plan1.stat1.value': 'Ilimitadas',
    'landing.pricing.candidates.plan1.stat1.label': 'postulaciones por mes',
    'landing.pricing.candidates.plan1.stat2.value': '24/7',
    'landing.pricing.candidates.plan1.stat2.label': 'acceso a vacantes activas',
    'landing.pricing.candidates.plan1.cta': 'Crear mi perfil gratis',
    'landing.pricing.candidates.plan2.badge': 'Recomendado',
    'landing.pricing.candidates.plan2.name': 'Premium',
    'landing.pricing.candidates.plan2.description': 'Todo lo de Free, m\u00e1s inteligencia artificial para potenciar tu hoja de vida y hacer que las empresas te encuentren primero.',
    'landing.pricing.candidates.plan2.price': '$ 9',
    'landing.pricing.candidates.plan2.cycle': '/ mes',
    'landing.pricing.candidates.plan2.metric': 'Nuestra IA trabaja para ti: mejora tu CV, destaca tus fortalezas, te avisa de los matches perfectos y te prepara para cada entrevista.',
    'landing.pricing.candidates.plan2.helper': 'Perfecto si ya est\u00e1s aplicando activamente y quieres acelerar cada etapa del proceso.',
    'landing.pricing.candidates.plan2.ideal': 'Acelera tu b\u00fasqueda con IA',
    'landing.pricing.candidates.plan2.feature1': 'Todo lo incluido en Free',
    'landing.pricing.candidates.plan2.feature2': 'Instant CV Feedback: sugerencias de IA para optimizar tu hoja de vida',
    'landing.pricing.candidates.plan2.feature3': 'Fortalezas destacadas autom\u00e1ticamente ante los reclutadores',
    'landing.pricing.candidates.plan2.feature4': 'Alertas inteligentes de vacantes "Perfect Match"',
    'landing.pricing.candidates.plan2.feature5': 'Simulador de entrevistas con preguntas reales por rol',
    'landing.pricing.candidates.plan2.feature6': 'Perfil destacado: apareces primero en los resultados de b\u00fasqueda',
    'landing.pricing.candidates.plan2.stat1.value': '3x',
    'landing.pricing.candidates.plan2.stat1.label': 'm\u00e1s visibilidad ante reclutadores',
    'landing.pricing.candidates.plan2.stat2.value': 'Top',
    'landing.pricing.candidates.plan2.stat2.label': 'prioridad en resultados afines',
    'landing.pricing.candidates.plan2.cta': 'Activar Premium',
    'landing.pricing.reasons.title': 'Por qu\u00e9 miles de usuarios eligen WeMatch',
    'landing.pricing.reasons.1.title': 'Cero fraude',
    'landing.pricing.reasons.1.body':
      'Validamos identidad y habilidades t\u00e9cnicas de forma autom\u00e1tica para garantizar honestidad.',
    'landing.pricing.reasons.2.title': '10x m\u00e1s r\u00e1pido',
    'landing.pricing.reasons.2.body':
      'Reduce el tiempo de contrataci\u00f3n de semanas a solo un par de d\u00edas con el filtrado inteligente.',
    'landing.pricing.reasons.3.title': 'Sin sesgos',
    'landing.pricing.reasons.3.body':
      'Nuestra IA se enfoca en el talento, eliminando prejuicios inconscientes en el proceso inicial.',
    'landing.pricing.faq.title': 'Preguntas frecuentes',
    'landing.pricing.faq.1.title': '\u00bfPuedo cancelar mi suscripci\u00f3n en cualquier momento?',
    'landing.pricing.faq.1.body':
      'S\u00ed. No hay contratos forzosos ni permanencia m\u00ednima: puedes cancelar o cambiar de plan cuando quieras desde tu cuenta, sin penalidades ni preguntas.',
    'landing.pricing.faq.2.title': '\u00bfQu\u00e9 incluye la prueba gratuita para empresas?',
    'landing.pricing.faq.2.body':
      'Tu prueba gratuita de 7 d\u00edas te da acceso completo a las funciones Premium (hojas de vida, resultados de evaluaci\u00f3n y anal\u00edtica comparativa) sin necesidad de tarjeta. Al terminar, eliges el plan que se ajuste a tu equipo o sigues en Free sin costo.',
    'landing.pricing.faq.3.title': '\u00bfC\u00f3mo funciona el AI Interview Prep para candidatos?',
    'landing.pricing.faq.3.body':
      'Nuestro simulador de IA te hace las preguntas m\u00e1s probables para el puesto al que aplicas, eval\u00faa tus respuestas y te da feedback instant\u00e1neo para que llegues m\u00e1s preparado a la entrevista real. Est\u00e1 incluido en el plan Premium.',

    'landing.contact.eyebrow': 'Contacto',
    'landing.contact.title': 'Estamos aqu\u00ed para impulsar tu talento.',
    'landing.contact.body':
      'Cu\u00e9ntanos si quieres atraer mejor talento, explorar nuevas oportunidades o simplemente resolver una duda sobre WeMatch.',
    'landing.contact.form.title': '\u00bfNecesitas ayuda?',
    'landing.contact.form.subtitle':
      'Nuestro equipo est\u00e1 listo para responder tus preguntas sobre la plataforma, precios, integraciones o soporte.',
    'landing.contact.form.schedule': 'Tiempo promedio de respuesta: 24 horas',
    'landing.contact.form.name': 'Nombre completo',
    'landing.contact.form.namePlaceholder': 'Escribe tu nombre',
    'landing.contact.form.email': 'Correo electr\u00f3nico',
    'landing.contact.form.emailPlaceholder': 'tu@correo.com',
    'landing.contact.form.company': 'Empresa',
    'landing.contact.form.companyPlaceholder': 'Nombre de la empresa',
    'landing.contact.form.topic': '\u00bfC\u00f3mo podemos ayudarte?',
    'landing.contact.form.topicPlaceholder': 'Selecciona una opci\u00f3n',
    'landing.contact.form.topic1': 'Quiero una demo',
    'landing.contact.form.topic2': 'Precios',
    'landing.contact.form.topic3': 'Integraciones',
    'landing.contact.form.topic4': 'Consulta general',
    'landing.contact.form.message': 'Cu\u00e9ntanos m\u00e1s',
    'landing.contact.form.messagePlaceholder': 'Describe brevemente tu consulta',
    'landing.contact.form.note':
      'El formulario queda en modo visual por ahora. Luego conectaremos el env\u00edo real.',
    'landing.contact.form.cta': 'Enviar mensaje',
    'landing.contact.info.title': 'Informaci\u00f3n de contacto',
    'landing.contact.info.subtitle': 'Tambi\u00e9n puedes escribirnos o agendar una conversaci\u00f3n con nuestro equipo.',
    'landing.contact.info.emailTitle': 'Escr\u00edbenos',
    'landing.contact.info.emailValue': 'hello@wematch.team',
    'landing.contact.info.phoneTitle': 'Ll\u00e1manos',
    'landing.contact.info.phoneValue': '+57 300 123 4566',
    'landing.contact.info.hoursTitle': 'Horario de atenci\u00f3n',
    'landing.contact.info.hoursValue': '9:00 AM - 6:00 PM (COT)',
    'landing.contact.aside.title': 'Estamos listos para ayudarte',
    'landing.contact.aside.body':
      'Ya sea para contratar mejor, mejorar tu proceso o activar una demo, te acompa\u00f1amos en el siguiente paso.',

    'landing.about.eyebrow': 'Sobre nosotros',
    'landing.about.title': 'Dise\u00f1amos una forma m\u00e1s clara, justa y accionable de contratar.',
    'landing.about.body':
      'WeMatch nace para bajar ruido, reducir sesgos y ayudar a que empresas y candidatos se encuentren con mejor contexto, mejor evidencia y mejores decisiones.',
    'landing.about.hero.chip1': 'Decisiones con evidencia',
    'landing.about.hero.chip2': 'Tecnolog\u00eda \u00fatil para talento',
    'landing.about.hero.chip3': 'Experiencias m\u00e1s humanas',
    'landing.about.hero.primary': 'Ver soluciones para empresas',
    'landing.about.hero.secondary': 'Crear perfil gratis',
    'landing.about.hero.boardLabel': 'Por qu\u00e9 existimos',
    'landing.about.hero.boardTitle': 'Convertimos fricci\u00f3n de reclutamiento en claridad operativa',
    'landing.about.hero.boardBody':
      'No creemos en procesos llenos de ruido, intuiciones sin trazabilidad o filtros que castigan buen talento. Dise\u00f1amos para decidir mejor desde el inicio.',
    'landing.about.hero.stat1.value': '70%',
    'landing.about.hero.stat1.label': 'menos tiempo operativo en el primer filtro',
    'landing.about.hero.stat2.value': 'IA + criterio',
    'landing.about.hero.stat2.label': 'automatizaci\u00f3n con lectura real del contexto',
    'landing.about.hero.stat3.value': '360\u00b0',
    'landing.about.hero.stat3.label': 'visi\u00f3n compartida entre equipo y candidato',
    'landing.about.hero.floating1': 'Procesos m\u00e1s trazables',
    'landing.about.hero.floating2': 'Menos sesgo. M\u00e1s contexto.',
    'landing.about.metrics.1.value': '+120k',
    'landing.about.metrics.1': 'perfiles analizados con mejor contexto',
    'landing.about.metrics.2.value': '+18',
    'landing.about.metrics.2': 'pa\u00edses conectando talento remoto',
    'landing.about.metrics.3.value': '+300',
    'landing.about.metrics.3': 'equipos usando flujos m\u00e1s claros',
    'landing.about.metrics.4.value': '24/7',
    'landing.about.metrics.4': 'plataforma lista para operar y evaluar',
    'landing.about.story.eyebrow': 'Nuestra historia',
    'landing.about.story.title': 'Construimos una plataforma para mejorar c\u00f3mo se decide el talento',
    'landing.about.story.body':
      'La historia de WeMatch no va de hacer un ATS m\u00e1s. Va de corregir una experiencia rota para que reclutar sea m\u00e1s confiable, m\u00e1s r\u00e1pido y mucho menos arbitrario.',
    'landing.about.story.cardLabel': 'Nuestra apuesta',
    'landing.about.story.cardTitle': 'Producto con criterio, no automatizaci\u00f3n vac\u00eda',
    'landing.about.story.cardBody':
      'Cada capa del producto busca unir velocidad con trazabilidad, automatizaci\u00f3n con explicaci\u00f3n y eficiencia con una experiencia m\u00e1s justa.',
    'landing.about.story.point1': 'Automatizar sin perder lectura humana del proceso.',
    'landing.about.story.point2': 'Reducir fricci\u00f3n para equipos, reclutadores y candidatos.',
    'landing.about.story.point3': 'Traducir se\u00f1ales complejas en decisiones accionables.',
    'landing.about.timeline.1.title': 'Detectamos un problema repetido',
    'landing.about.timeline.1.body':
      'Vimos procesos lentos, decisiones opacas y talento valioso quedando fuera por filtros pobres o sesgados.',
    'landing.about.timeline.2.title': 'Dise\u00f1amos la primera base del producto',
    'landing.about.timeline.2.body':
      'Creamos una experiencia enfocada en ordenar pipeline, validar se\u00f1ales y dar contexto a cada etapa del proceso.',
    'landing.about.timeline.3.title': 'Probamos y refinamos con equipos reales',
    'landing.about.timeline.3.body':
      'Convertimos feedback operativo en mejoras de evaluaci\u00f3n, seguimiento, visibilidad y soporte para decisiones m\u00e1s r\u00e1pidas.',
    'landing.about.timeline.4.title': 'Evolucionamos hacia inteligencia aplicada',
    'landing.about.timeline.4.body':
      'Integramos IA para priorizar mejor, explicar mejor y acompa\u00f1ar mejor cada flujo sin convertirlo en una caja negra.',
    'landing.about.principles.eyebrow': 'C\u00f3mo pensamos',
    'landing.about.principles.title': 'Los principios que sostienen cada decisi\u00f3n del producto',
    'landing.about.principles.body':
      'No son frases de pared. Son criterios de dise\u00f1o, operaci\u00f3n y producto que usamos para priorizar lo que realmente aporta valor.',
    'landing.about.principles.1.title': 'Transparencia operativa',
    'landing.about.principles.1.body': 'Cada paso debe explicar qu\u00e9 pas\u00f3, por qu\u00e9 pas\u00f3 y qu\u00e9 sigue despu\u00e9s.',
    'landing.about.principles.2.title': 'Equidad con contexto',
    'landing.about.principles.2.body': 'Reducimos sesgo al evaluar mejor las se\u00f1ales, no simplificando a las personas.',
    'landing.about.principles.3.title': 'Velocidad con criterio',
    'landing.about.principles.3.body': 'Automatizar solo tiene sentido si ayuda a decidir m\u00e1s r\u00e1pido y mejor.',
    'landing.about.principles.4.title': 'Tecnolog\u00eda accionable',
    'landing.about.principles.4.body': 'La IA debe traducirse en recomendaciones claras, no en complejidad innecesaria.',
    'landing.about.principles.5.title': 'Experiencia consistente',
    'landing.about.principles.5.body': 'Cuidamos cada punto de contacto para que producto, contenido y flujo hablen el mismo idioma.',
    'landing.about.principles.6.title': 'Valor verificable',
    'landing.about.principles.6.body': 'Nos importa que el impacto se note en tiempo, claridad, confianza y capacidad de cierre.',
    'landing.about.impact.eyebrow': 'Impacto real',
    'landing.about.impact.title': 'El valor de WeMatch cambia seg\u00fan a qui\u00e9n acompa\u00f1a, pero siempre busca la misma meta',
    'landing.about.impact.body':
      'Para empresas, significa decisiones m\u00e1s claras y procesos m\u00e1s escalables. Para candidatos, significa mejor visibilidad, mejor feedback y una experiencia m\u00e1s justa.',
    'landing.about.impact.companies.eyebrow': 'Para empresas',
    'landing.about.impact.companies.title': 'Equipos que necesitan decidir mejor sin frenar la operaci\u00f3n',
    'landing.about.impact.companies.body':
      'Consolidamos evaluaci\u00f3n, trazabilidad y automatizaci\u00f3n para que cada vacante tenga m\u00e1s contexto y menos desgaste operativo.',
    'landing.about.impact.companies.point1': 'Visibilidad del pipeline sin perder velocidad.',
    'landing.about.impact.companies.point2': 'Comparativos m\u00e1s claros para priorizar mejor.',
    'landing.about.impact.companies.point3': 'Menos trabajo manual, m\u00e1s foco en la decisi\u00f3n final.',
    'landing.about.impact.companies.stat.value': '2x',
    'landing.about.impact.companies.stat.label': 'm\u00e1s claridad al revisar perfiles y etapas',
    'landing.about.impact.companies.cta': 'Conocer flujo para empresas',
    'landing.about.impact.candidates.eyebrow': 'Para candidatos',
    'landing.about.impact.candidates.title': 'Profesionales que merecen mostrarse mejor y competir con m\u00e1s contexto',
    'landing.about.impact.candidates.body':
      'Ayudamos a que el perfil se lea mejor, que las fortalezas tengan m\u00e1s visibilidad y que cada postulaci\u00f3n se sienta menos ciega.',
    'landing.about.impact.candidates.point1': 'Feedback m\u00e1s claro para mejorar perfil y narrativa.',
    'landing.about.impact.candidates.point2': 'Alertas y vacantes m\u00e1s alineadas al contexto real.',
    'landing.about.impact.candidates.point3': 'Preparaci\u00f3n m\u00e1s consistente antes de entrevistas.',
    'landing.about.impact.candidates.stat.value': '24/7',
    'landing.about.impact.candidates.stat.label': 'acceso continuo a perfil, alertas y seguimiento',
    'landing.about.impact.candidates.cta': 'Crear perfil en WeMatch',
    'landing.about.cta.eyebrow': 'Lo que sigue',
    'landing.about.cta.title': 'Estamos construyendo una forma m\u00e1s confiable de conectar talento y oportunidad',
    'landing.about.cta.body':
      'Si tu equipo necesita contratar con m\u00e1s claridad o si quieres mostrar mejor tu perfil profesional, WeMatch est\u00e1 dise\u00f1ado para acompa\u00f1ar ese siguiente paso.',
    'landing.about.cta.button': 'Hablar con el equipo',

    'landing.privacy.title': 'Pol\u00edtica de Privacidad',
    'landing.privacy.updatedAt': '\u00daltima actualizaci\u00f3n: 28 de mayo de 2026',
    'landing.privacy.intro':
      'Este contenido es de ejemplo y se reemplazar\u00e1 por el texto legal definitivo antes de publicaci\u00f3n.',
    'landing.privacy.contactLabel': 'Canal de contacto',
    'landing.privacy.contactValue': 'privacy@wematch.team',
    'landing.privacy.section1.title': 'Informaci\u00f3n que recopilamos',
    'landing.privacy.section1.body':
      'Podemos recopilar datos de identificaci\u00f3n, informaci\u00f3n de contacto, datos profesionales y actividad de uso dentro de la plataforma.',
    'landing.privacy.section2.title': 'C\u00f3mo usamos tus datos',
    'landing.privacy.section2.body':
      'Utilizamos esta informaci\u00f3n para operar la plataforma, mejorar la experiencia y mantener procesos seguros.',
    'landing.privacy.section2.item1': 'Crear y administrar cuentas',
    'landing.privacy.section2.item2': 'Mejorar recomendaciones y flujos de postulaci\u00f3n',
    'landing.privacy.section2.item3': 'Detectar fraude y proteger la plataforma',
    'landing.privacy.section3.title': 'Base legal y consentimiento',
    'landing.privacy.section3.body':
      'Tratamos los datos de acuerdo con el consentimiento, la ejecuci\u00f3n contractual y las necesidades leg\u00edtimas para el funcionamiento del servicio.',
    'landing.privacy.section4.title': 'Conservaci\u00f3n de datos',
    'landing.privacy.section4.body':
      'Conservamos la informaci\u00f3n durante el tiempo necesario para brindar el servicio, cumplir obligaciones legales y resolver disputas razonables.',
    'landing.privacy.section5.title': 'Compartir informaci\u00f3n',
    'landing.privacy.section5.body':
      'Podemos compartir informaci\u00f3n con proveedores operativos y aliados tecnol\u00f3gicos bajo acuerdos de confidencialidad y seguridad.',
    'landing.privacy.section6.title': 'Tus derechos',
    'landing.privacy.section6.body':
      'Puedes solicitar acceso, actualizaci\u00f3n, correcci\u00f3n o eliminaci\u00f3n de datos personales escribi\u00e9ndonos a nuestro canal de privacidad.',

    'landing.terms.title': 'T\u00e9rminos y Condiciones de Uso',
    'landing.terms.updatedAt': '\u00daltima actualizaci\u00f3n: 28 de mayo de 2026',
    'landing.terms.intro':
      'Este documento es temporal y funciona como dummy mientras el equipo legal entrega la versi\u00f3n oficial.',
    'landing.terms.contactLabel': 'Email',
    'landing.terms.contactValue': 'info@wematch.team',
    'landing.terms.section1.title': 'Aceptaci\u00f3n de los t\u00e9rminos',
    'landing.terms.section1.body':
      'Al acceder y utilizar la plataforma usted acepta estar sujeto a estos t\u00e9rminos y condiciones de uso.',
    'landing.terms.section2.title': 'Descripci\u00f3n del servicio',
    'landing.terms.section2.body':
      'WeMatch ofrece herramientas para conectar empresas y candidatos, publicar vacantes y facilitar evaluaciones iniciales.',
    'landing.terms.section3.title': 'Registro de cuenta',
    'landing.terms.section3.body':
      'Para utilizar ciertas funciones es necesario crear una cuenta. Usted se compromete a:',
    'landing.terms.section3.item1': 'Proporcionar informaci\u00f3n precisa y actualizada',
    'landing.terms.section3.item2': 'Mantener la confidencialidad de sus credenciales',
    'landing.terms.section3.item3': 'Notificar el uso no autorizado de su cuenta',
    'landing.terms.section3.item4': 'Asumir responsabilidad sobre la actividad registrada',
    'landing.terms.section4.title': 'Uso aceptable',
    'landing.terms.section4.body':
      'Al utilizar WeMatch, usted acepta no realizar acciones que afecten la integridad del servicio o de terceros.',
    'landing.terms.section4.item1': 'Publicar contenido falso o enga\u00f1oso',
    'landing.terms.section4.item2': 'Vulnerar derechos de terceros',
    'landing.terms.section4.item3': 'Intentar acceder a sistemas sin autorizaci\u00f3n',
    'landing.terms.section4.item4': 'Interferir con el funcionamiento normal de la plataforma',
    'landing.terms.section5.title': 'Propiedad intelectual',
    'landing.terms.section5.body':
      'Los contenidos, dise\u00f1os y componentes del servicio son propiedad de WeMatch o de sus licenciantes y no pueden reutilizarse sin autorizaci\u00f3n.',
    'landing.terms.section6.title': 'Privacidad y protecci\u00f3n de datos',
    'landing.terms.section6.body':
      'El uso de datos personales se rige por nuestra Pol\u00edtica de Privacidad y por las normas aplicables a la operaci\u00f3n del servicio.',
    'landing.terms.section7.title': 'Limitaci\u00f3n de responsabilidad',
    'landing.terms.section7.body':
      'WeMatch no ser\u00e1 responsable por da\u00f1os indirectos, incidentales o consecuenciales derivados del uso o imposibilidad de uso del servicio.',
    'landing.terms.section8.title': 'Modificaciones del servicio y de los t\u00e9rminos',
    'landing.terms.section8.body':
      'Podemos actualizar estos t\u00e9rminos o ajustar funcionalidades del servicio. El uso continuado implicar\u00e1 aceptaci\u00f3n de los cambios.',
  },
  en: {
    'landing.nav.home': 'Home',
    'landing.nav.companies': 'For Companies',
    'landing.nav.candidates': 'For Candidates',
    'landing.nav.pricing': 'Pricing',
    'landing.nav.contact': 'Contact',
    'landing.nav.login': 'Log in',
    'landing.nav.register': 'Sign up',

    'landing.hero.stats.time': 'Less hiring time',
    'landing.hero.stats.companies': 'Companies that trust us',
    'landing.hero.stats.satisfaction': 'Candidate satisfaction',
    'landing.hero.companies.headline':
      'WeMatch:<br><span>AI that connects talent<br>with opportunities.</span>',
    'landing.hero.companies.body':
      'WeMatch uses artificial intelligence to connect companies with the right talent, in a faster, fairer, and more reliable way.',
    'landing.hero.companies.primary': 'Start your 7 day free trial',
    'landing.hero.companies.secondary': 'Sign up free',
    'landing.hero.companies.imageAlt': 'WeMatch companies hero',
    'landing.hero.companies.floatingTop': 'More than 10,000 candidates',
    'landing.hero.companies.floatingBottomTitle': 'Upload your resume',
    'landing.hero.companies.floatingBottomText': 'It only takes a few seconds',
    'landing.hero.candidates.headline':
      'Find real<br>opportunities,<br><span>without bias or<br>complications.</span>',
    'landing.hero.candidates.body':
      'Create your profile, verify your identity, and apply in minutes. Our AI connects your talent with the best opportunities in a fair and transparent way.',
    'landing.hero.candidates.primary': 'Create free profile',
    'landing.hero.candidates.secondary': 'Explore jobs',
    'landing.hero.candidates.imageAlt': 'WeMatch candidates hero',
    'landing.hero.candidates.floatingTop': '3 new roles for you',
    'landing.hero.candidates.floatingBottomTitle': 'Match found',
    'landing.hero.candidates.floatingBottomText': 'It only takes a few seconds',

    'landing.problem.title': 'Traditional recruiting is slow, costly, and inefficient',
    'landing.problem.subtitle':
      'Companies lose valuable time manually reviewing hundreds of resumes, running low value interviews, and dealing with unqualified candidates.',
    'landing.problem.imageAlt': 'Problem section image',
    'landing.problem.stat1.suffix': ' Days',
    'landing.problem.stat1.title': 'Average',
    'landing.problem.stat1.text':
      'Time required to hire with traditional methods, causing productivity losses.',
    'landing.problem.stat2.prefix': '+ ',
    'landing.problem.stat2.suffix': '',
    'landing.problem.stat2.title': 'Applications',
    'landing.problem.stat2.text':
      'Per opening that must be reviewed manually, consuming HR hours.',
    'landing.problem.stat3.suffix': '%',
    'landing.problem.stat3.prefix': 'Up to ',
    'landing.problem.stat3.title': 'of Fraud',
    'landing.problem.stat3.text':
      'In resume information, from inflated skills to false identities.',

    'landing.solution.title': 'WeMatch automates the entire process with artificial intelligence',
    'landing.solution.subtitle':
      'We use artificial intelligence to reduce hiring time by 70%, validate candidates automatically, and guarantee transparent and fair processes.',
    'landing.solution.companies.title': 'For Companies',
    'landing.solution.companies.item1': 'Automatic CV screening with up to 99% precision.',
    'landing.solution.companies.item2': 'Automated technical evaluation powered by artificial intelligence.',
    'landing.solution.companies.item3': 'Identity and real experience validation.',
    'landing.solution.companies.item4': 'Match reports based on soft skills.',
    'landing.solution.companies.primary': 'Optimize My Hiring',
    'landing.solution.candidates.title': 'For Candidates',
    'landing.solution.candidates.item1': 'Upload your profile once and apply to hundreds of roles.',
    'landing.solution.candidates.item2': 'Instant feedback on your resume and skills.',
    'landing.solution.candidates.item3':
      'AI that highlights your real strengths for recruiters.',
    'landing.solution.candidates.item4': 'Learning paths to close technical gaps.',
    'landing.solution.candidates.primary': 'Boost My Career',
    'landing.solution.candidates.secondary': 'Explore jobs',

    'landing.testimonials.title': 'What companies and candidates already using WeMatch say',
    'landing.testimonials.previous': 'Previous',
    'landing.testimonials.next': 'Next',
    'landing.testimonials.pagination': 'Testimonials pagination',
    'landing.testimonials.goToGroup': 'Go to group {group}',
    'landing.testimonials.1.quote':
      '"WeMatch changed the game. We went from 2 months to hire a Senior Dev to only 12 days. The AI accuracy is impressive."',
    'landing.testimonials.1.name': 'Elena Rivas',
    'landing.testimonials.1.role': 'Head of Talent, FinTech Solutions',
    'landing.testimonials.2.quote':
      '"The best part is the drastic reduction in fraud. Now we know exactly what a candidate can do before the first human call."',
    'landing.testimonials.2.name': 'Marcos Benitez',
    'landing.testimonials.2.role': 'CTO, CloudScale Systems',
    'landing.testimonials.3.quote':
      '"The integration was seamless. My recruiting team now focuses on culture, not on discarding irrelevant resumes."',
    'landing.testimonials.3.name': 'Sara Velasco',
    'landing.testimonials.3.role': 'Lead Recruiter, Global Logix',
    'landing.testimonials.4.quote':
      '"The accuracy of the initial filter gave us real time back. Now every interview makes sense and we do not waste energy on the wrong profiles."',
    'landing.testimonials.4.name': 'Camila Duarte',
    'landing.testimonials.4.role': 'Talent Lead, Nova Growth',
    'landing.testimonials.5.quote':
      '"We used to spend hours reviewing resumes. With WeMatch we now focus on decisions, not administration."',
    'landing.testimonials.5.name': 'Jorge Marin',
    'landing.testimonials.5.role': 'People Director, Vector Labs',
    'landing.testimonials.6.quote':
      '"I uploaded my profile once and in less than a week I already had matches much closer to my real experience."',
    'landing.testimonials.6.name': 'Andrea Pardo',
    'landing.testimonials.6.role': 'Product Designer Candidate',
    'landing.testimonials.7.quote':
      '"The immediate feedback helped me improve my profile from the first attempt. Applying feels much clearer now."',
    'landing.testimonials.7.name': 'Daniel Ocampo',
    'landing.testimonials.7.role': 'Backend Candidate',
    'landing.testimonials.8.quote':
      '"Closing speed improved without sacrificing quality. We hired faster and with much less friction in the process."',
    'landing.testimonials.8.name': 'Laura Quintana',
    'landing.testimonials.8.role': 'COO, Blue Orbit',
    'landing.testimonials.9.quote':
      '"The most valuable thing was trust. The system detected inconsistencies that a traditional process would have missed."',
    'landing.testimonials.9.name': 'Felipe Suaza',
    'landing.testimonials.9.role': 'Recruitment Manager, Altitude Tech',
    'landing.testimonials.10.quote':
      '"For the first time my profile was competing on real capabilities and not only on keywords on a resume."',
    'landing.testimonials.10.name': 'Paula Rios',
    'landing.testimonials.10.role': 'Frontend Candidate',

    'landing.demo.title': 'See the Platform in Action',
    'landing.demo.tabLabel': 'Demo type',
    'landing.demo.tabCompanies': 'For Companies',
    'landing.demo.tabCandidates': 'For Candidates',
    'landing.demo.play': 'Play demo video',
    'landing.demo.pause': 'Pause video',
    'landing.demo.restart': 'Restart video',
    'landing.demo.mute': 'Mute video',
    'landing.demo.unmute': 'Unmute video',
    'landing.demo.fullscreen': 'View fullscreen',
    'landing.demo.exitFullscreen': 'Exit fullscreen',
    'landing.demo.progress': 'Video progress',
    'landing.demo.primary': 'Start your 7 day free trial',
    'landing.demo.secondary': 'Sign up free',
    'landing.demo.close': 'Close video',
    'landing.demo.fallback': 'Your browser does not support HTML5 video.',

    'landing.explore.breadcrumb': 'Breadcrumb',
    'landing.explore.current': 'Explore jobs',
    'landing.explore.searchLabel': 'Search jobs',
    'landing.explore.searchPlaceholder': 'Search by keyword',
    'landing.explore.filter': 'Filter',
    'landing.explore.perPage': '{count} per page',
    'landing.explore.clearFilters': 'Clear filters',
    'landing.explore.resetFilters': 'Reset filters',
    'landing.explore.results.none': 'No roles matched those filters.',
    'landing.explore.results.one': '1 role available',
    'landing.explore.results.many': '{count} roles available',
    'landing.explore.empty.title': 'We could not find roles for those filters',
    'landing.explore.empty.body': 'Adjust the filters or clear the search to see more results.',
    'landing.explore.filters.eyebrow': 'Explore jobs',
    'landing.explore.filters.title': 'Filter jobs',
    'landing.explore.filters.close': 'Close filters',
    'landing.explore.filters.perPageLabel': 'Results per page',
    'landing.explore.filters.area': 'Area / category',
    'landing.explore.filters.contractType': 'Contract type',
    'landing.explore.filters.city': 'City',
    'landing.explore.filters.experience': 'Experience',
    'landing.explore.filters.salary': 'Salary',
    'landing.explore.filters.selectOption': 'Select an option',
    'landing.explore.filters.clear': 'Clear',
    'landing.explore.filters.find': 'Find jobs',
    'landing.explore.card.highDemand': 'High demand',
    'landing.explore.card.published': 'Published',
    'landing.explore.card.applicants': 'applicants',
    'landing.explore.detail.close': 'Close details',
    'landing.explore.detail.share': 'Share role',
    'landing.explore.detail.apply': 'Apply now',
    'landing.explore.detail.description': 'Role description',
    'landing.explore.detail.highDemand': 'High demand',
    'landing.explore.detail.requirements': 'Requirements',
    'landing.explore.detail.stack': 'Stack and skills',
    'landing.explore.detail.perks': 'Perks',
    'landing.explore.detail.unlockTitle': 'Apply to unlock the full role details',
    'landing.explore.detail.unlockBody':
      'Sign up on WeMatch to see the full role information and apply right away.',
    'landing.explore.detail.unlockAction': 'Apply now',
    'landing.preferences.interface': 'Interface preferences',
    'landing.preferences.language': 'Language',

    'landing.footer.tagline':
      'Connecting intelligence with opportunities. Redefining the standard for fair and efficient hiring.',
    'landing.footer.followUs': 'Follow us on',
    'landing.footer.product': 'Product',
    'landing.footer.companies': 'For Companies',
    'landing.footer.candidates': 'For Candidates',
    'landing.footer.howItWorks': 'How it works',
    'landing.footer.pricing': 'Pricing',
    'landing.footer.company': 'Company',
    'landing.footer.about': 'About us',
    'landing.footer.support': 'Contact support',
    'landing.footer.legal': 'Legal',
    'landing.footer.privacy': 'Privacy Policy',
    'landing.footer.terms': 'Terms and Conditions',
    'landing.footer.rights': 'All rights reserved.',

    'landing.companies.hero.eyebrow': 'For companies',
    'landing.companies.hero.title':
      'Find the <span>right talent</span> without bias or delays.',
    'landing.companies.hero.body':
      'WeMatch uses advanced Artificial Intelligence to connect companies with the ideal candidates, optimizing every stage of the selection process.',
    'landing.companies.hero.primary': 'Start your 7 day free trial',
    'landing.companies.hero.secondary': 'Sign up free',
    'landing.companies.hero.badgeTop': 'Smart analysis active',
    'landing.companies.hero.badgeBottom': 'Validation in seconds',
    'landing.companies.hero.imageAlt': 'Main companies view',
    'landing.companies.stats.1': 'Average time to hire',
    'landing.companies.stats.2': 'Qualified candidates per opening',
    'landing.companies.stats.3.value': 'Zero Bias',
    'landing.companies.stats.3': 'Fair screening layer',
    'landing.companies.stats.4.value': 'Global',
    'landing.companies.stats.4': 'Remote ready talent reach',
    'landing.companies.results.title': 'Results that transform your hiring team',
    'landing.companies.results.card1.caption': 'Average per role',
    'landing.companies.results.card1.imageAlt': 'Hourglass measuring hiring time',
    'landing.companies.results.body':
      'Our technology does not just speed up the process, it also guarantees the quality of every hire.',
    'landing.companies.results.card1.label': 'Peak efficiency',
    'landing.companies.results.card1.title': 'Hiring time reduced by half.',
    'landing.companies.results.card1.metric': 'Days',
    'landing.companies.results.card2.body': 'Qualified candidates for every published opening.',
    'landing.companies.results.card3.title': 'Zero Bias AI',
    'landing.companies.results.card3.body':
      'Algorithms designed to reduce unconscious bias from the earliest stage.',
    'landing.companies.results.card4.title': 'Global Talent',
    'landing.companies.results.card4.body':
      'Access a ready to interview talent base for remote and distributed teams.',
    'landing.companies.results.card4.imageAlt': 'Collaborative work team',
    'landing.companies.steps.1.title': 'Publish your role',
    'landing.companies.steps.1.body':
      'Create the opening with goals, seniority and stack. We structure the base evaluation for you.',
    'landing.companies.steps.2.title': 'Automated evaluation',
    'landing.companies.steps.2.body':
      'AI reviews background, compatibility and risk signals before the first human call.',
    'landing.companies.steps.3.title': 'Identity validation',
    'landing.companies.steps.3.body':
      'We verify key information to reduce document fraud and improve trust across the process.',
    'landing.companies.steps.4.title': 'Hire with confidence',
    'landing.companies.steps.4.body':
      'Receive shortlists, comparison analysis and evidence in one place to move faster.',
    'landing.companies.process.title': 'How does WeMatch work?',
    'landing.companies.process.body':
      'A guided workflow to attract, automate and validate candidates without losing visibility.',
    'landing.companies.process.cta': 'See plans',
    'landing.companies.process.panelTitle': 'Profile analysis #4821',
    'landing.companies.process.panelBadge': 'Ready to review',
    'landing.companies.process.metric1': 'Technical compatibility',
    'landing.companies.process.metric2': 'Leadership signals',
    'landing.companies.process.metric3': 'Culture fit',
    'landing.companies.process.chip1': 'Code validated',
    'landing.companies.process.chip2': 'Bias free',
    'landing.companies.process.chip3': 'Secure process',
    'landing.companies.cta.title': 'Ready to transform your talent team?',
    'landing.companies.cta.body':
      'Start today and discover why leading companies trust WeMatch to scale their teams.',
    'landing.companies.cta.button': 'Request your 7 day free trial',
    'landing.companies.cta.note': 'No hidden costs. No minimum commitment periods.',

    'landing.candidates.hero.eyebrow': 'For candidates',
    'landing.candidates.hero.title':
      'Your next <span>great opportunity</span> is already looking for you.',
    'landing.candidates.hero.body':
      'Find real openings that fit your profile, without the hassle. Power up your resume with our AI and showcase your strengths automatically.',
    'landing.candidates.hero.primary': 'Create your free profile',
    'landing.candidates.hero.secondary': 'Explore jobs',
    'landing.candidates.hero.search': 'Job search...',
    'landing.candidates.hero.imageAlt': 'Main candidates view',
    'landing.candidates.hero.cardLabel': 'Top compatibility',
    'landing.candidates.hero.cardTitle': 'Your profile is almost ready to stand out',
    'landing.candidates.hero.cardBody':
      'Strengths, validation and a clearer narrative aligned to move you faster.',
    'landing.candidates.hero.metric1': 'Product match',
    'landing.candidates.hero.metric2': 'Instant feedback',
    'landing.candidates.stats.1': 'Average application time',
    'landing.candidates.stats.2': 'Transparent and fair process',
    'landing.candidates.stats.3': 'Access to your profile and applications',
    'landing.candidates.stats.4': 'Cost for candidates',
    'landing.candidates.tools.title': 'Tools designed for your success',
    'landing.candidates.tools.body':
      'Our technology works so you can focus only on the interview.',
    'landing.candidates.tools.card1.title': 'Instant CV Feedback',
    'landing.candidates.tools.card1.body':
      'Upload your resume and get instant AI-based suggestions to optimize it against current tech market trends.',
    'landing.candidates.tools.card1.suggestionLabel': 'AI Suggestion',
    'landing.candidates.tools.card1.suggestion':
      '"Highlight your React project architecture experience..."',
    'landing.candidates.tools.card2.title': 'AI-Highlighted Strengths',
    'landing.candidates.tools.card2.body':
      'We analyze your achievements and automatically highlight your most valuable skills for recruiters.',
    'landing.candidates.tools.card2.item1': 'Leadership in Agile Teams',
    'landing.candidates.tools.card2.item2': 'Microservices Architecture',
    'landing.candidates.tools.card2.signal1': 'Profile clarity',
    'landing.candidates.tools.card2.signal2': 'Opening relevance',
    'landing.candidates.tools.card2.signal3': 'Interview potential',
    'landing.candidates.tools.card3.title': 'Smart Alerts',
    'landing.candidates.tools.card3.body':
      'Get notified only when an opening is a "Perfect Match" for your salary and career expectations.',
    'landing.candidates.tools.card3.badge': 'Active matches',
    'landing.candidates.tools.card3.alert1.title': 'Senior Angular Frontend',
    'landing.candidates.tools.card3.alert1.meta': 'Remote · Bogota / LATAM',
    'landing.candidates.tools.card3.alert1.tag': '94% match',
    'landing.candidates.tools.card3.alert2.title': 'Product Designer',
    'landing.candidates.tools.card3.alert2.meta': 'Hybrid · Medellin',
    'landing.candidates.tools.card3.alert2.tag': 'New',
    'landing.candidates.tools.card3.alert3.title': 'QA Automation Engineer',
    'landing.candidates.tools.card3.alert3.meta': 'Remote · Full time',
    'landing.candidates.tools.card3.alert3.tag': 'Strong fit',
    'landing.candidates.tools.card4.title': 'Interview Preparation',
    'landing.candidates.tools.card4.body':
      'Practice with our AI simulator, which asks you the most likely questions for the specific role you are applying to.',
    'landing.candidates.tools.card4.imageAlt': 'Video interview simulator',
    'landing.candidates.tools.card4.screenLabel': 'Video Interview Simulator',
    'landing.candidates.tools.card4.point1': 'Frequent questions by role',
    'landing.candidates.tools.card4.point2': 'Suggested answer structure',
    'landing.candidates.tools.card4.point3': 'More confidence before each call',
    'landing.candidates.tools.card4.badge': 'Interview mode',
    'landing.candidates.process.title': 'How does WeMatch work?',
    'landing.candidates.process.body':
      'Four simple steps to activate your profile, discover opportunities and apply with confidence.',
    'landing.candidates.steps.1.title': 'Create your profile',
    'landing.candidates.steps.1.body':
      'Import your resume and complete the most important details in minutes.',
    'landing.candidates.steps.2.title': 'Discover opportunities',
    'landing.candidates.steps.2.body':
      'Explore openings with context and filters designed for faster decisions.',
    'landing.candidates.steps.3.title': 'Apply easily',
    'landing.candidates.steps.3.body':
      'One profile lets you apply consistently across multiple openings.',
    'landing.candidates.steps.4.title': 'Receive feedback',
    'landing.candidates.steps.4.body':
      'Understand your strengths, gaps and recommended next steps.',
    'landing.candidates.process.panelLabel': 'Progress board',
    'landing.candidates.process.panelTitle': 'Your profile is almost ready to apply',
    'landing.candidates.process.panelBody':
      'Complete a few smart improvements and show up with stronger context to real hiring teams.',
    'landing.candidates.process.nextLabel': 'Next best action',
    'landing.candidates.process.nextValue': 'Add measurable outcomes to your latest experience',
    'landing.candidates.process.card1.title': 'Validated profile',
    'landing.candidates.process.card1.meta': 'Identity and core data completed',
    'landing.candidates.process.card2.title': 'Relevant openings',
    'landing.candidates.process.card2.meta': '3 new high-match opportunities',
    'landing.candidates.process.card3.title': 'Pending feedback',
    'landing.candidates.process.card3.meta': '2 suggestions to increase visibility',
    'landing.candidates.cta.title': 'Ready to find your next opportunity?',
    'landing.candidates.cta.body':
      'Create your profile today and stay ready for openings that truly match your background.',
    'landing.candidates.cta.button': 'Create your free profile',
    'landing.candidates.cta.note': 'Takes less than 2 minutes. No commitment.',

    'landing.pricing.eyebrow': 'Pricing',
    'landing.pricing.title': 'Plans designed to scale with better judgment',
    'landing.pricing.body':
      'Start free and upgrade only when you need more depth, more data or more artificial intelligence. No fine print.',
    'landing.pricing.tabLabel': 'Plan type',
    'landing.pricing.companies.tab': 'For Companies',
    'landing.pricing.candidates.tab': 'For Candidates',
    'landing.pricing.companies.summary.label': 'A simple model for talent teams',
    'landing.pricing.companies.summary.title': 'Start free. Scale when your team needs it.',
    'landing.pricing.companies.summary.body':
      'Post openings for free from day one. Upgrade only when you want access to resumes, evaluation results and advanced artificial intelligence.',
    'landing.pricing.companies.summary.chip1': 'No charge per internal recruiter',
    'landing.pricing.companies.summary.chip2': 'Start free, scale whenever you want',
    'landing.pricing.companies.summary.chip3': 'Advanced AI available from Pro',
    'landing.pricing.companies.summary.stat1.value': '$ 0 - $ 399',
    'landing.pricing.companies.summary.stat1.label': 'monthly investment range depending on plan',
    'landing.pricing.companies.summary.stat2.value': '1 team',
    'landing.pricing.companies.summary.stat2.label': 'collaborating without restricting internal team access',
    'landing.pricing.companies.plan1.badge': 'Free',
    'landing.pricing.companies.plan1.name': 'Free',
    'landing.pricing.companies.plan1.description': 'Post openings and start receiving qualified candidates, at no cost and no fine print.',
    'landing.pricing.companies.plan1.price': '$ 0',
    'landing.pricing.companies.plan1.cycle': '/ month',
    'landing.pricing.companies.plan1.metric': 'Your entry point to AI recruiting: active openings, smart shortlisting and basic tracking for every process.',
    'landing.pricing.companies.plan1.helper': 'Ideal if you are posting your first openings and want to try WeMatch with no commitment.',
    'landing.pricing.companies.plan1.ideal': 'Start recruiting with AI',
    'landing.pricing.companies.plan1.feature1': 'Unlimited job publishing',
    'landing.pricing.companies.plan1.feature2': 'Access to the active candidate pool',
    'landing.pricing.companies.plan1.feature3': 'Smart shortlist with initial ranking',
    'landing.pricing.companies.plan1.feature4': 'Application tracking dashboard',
    'landing.pricing.companies.plan1.stat1.value': '3',
    'landing.pricing.companies.plan1.stat1.label': 'simultaneous active openings',
    'landing.pricing.companies.plan1.stat2.value': 'Unlimited',
    'landing.pricing.companies.plan1.stat2.label': 'job openings you can post',
    'landing.pricing.companies.plan1.cta': 'Start for free',
    'landing.pricing.companies.plan2.badge': 'Recommended',
    'landing.pricing.companies.plan2.name': 'Premium',
    'landing.pricing.companies.plan2.description': 'Everything in Free, plus full access to resumes and evaluation results to decide with real data.',
    'landing.pricing.companies.plan2.price': '$ 149',
    'landing.pricing.companies.plan2.cycle': '/ month',
    'landing.pricing.companies.plan2.metric': 'Go deeper on every candidate: full resumes, test results and comparisons to filter with judgment, not guesswork.',
    'landing.pricing.companies.plan2.helper': 'Perfect for teams already screening actively and needing more than a basic profile.',
    'landing.pricing.companies.plan2.ideal': 'Data-driven recruiting',
    'landing.pricing.companies.plan2.feature1': 'Everything in Free',
    'landing.pricing.companies.plan2.feature2': 'Full access to resumes and candidate profiles',
    'landing.pricing.companies.plan2.feature3': 'Detailed evaluation and technical test results',
    'landing.pricing.companies.plan2.feature4': 'Comparative analytics across candidates',
    'landing.pricing.companies.plan2.feature5': 'Identity verification and anti-fraud signals',
    'landing.pricing.companies.plan2.stat1.value': '10',
    'landing.pricing.companies.plan2.stat1.label': 'simultaneous active openings',
    'landing.pricing.companies.plan2.stat2.value': '100%',
    'landing.pricing.companies.plan2.stat2.label': 'access to resumes and results',
    'landing.pricing.companies.plan2.cta': 'Choose Premium',
    'landing.pricing.companies.plan3.badge': 'Advanced AI',
    'landing.pricing.companies.plan3.name': 'Pro',
    'landing.pricing.companies.plan3.description': 'Everything in Free and Premium, plus end-to-end artificial intelligence to fully automate your hiring.',
    'landing.pricing.companies.plan3.price': '$ 399',
    'landing.pricing.companies.plan3.cycle': '/ month',
    'landing.pricing.companies.plan3.metric': 'AI does the heavy lifting: ranks candidates, flags bias and automates every stage so your team can focus on deciding.',
    'landing.pricing.companies.plan3.helper': 'Built for teams that want to scale hiring without scaling manual effort.',
    'landing.pricing.companies.plan3.ideal': 'Full recruiting automation',
    'landing.pricing.companies.plan3.feature1': 'Everything in Premium',
    'landing.pricing.companies.plan3.feature2': 'AI matching with automatic candidate ranking',
    'landing.pricing.companies.plan3.feature3': 'AI-simulated and AI-scored interviews',
    'landing.pricing.companies.plan3.feature4': 'Automatic bias detection at every stage',
    'landing.pricing.companies.plan3.feature5': 'Communication automations (reminders, follow-ups, responses)',
    'landing.pricing.companies.plan3.feature6': 'Priority support and dedicated onboarding',
    'landing.pricing.companies.plan3.stat1.value': 'Unlimited',
    'landing.pricing.companies.plan3.stat1.label': 'simultaneous active openings',
    'landing.pricing.companies.plan3.stat2.value': 'AI',
    'landing.pricing.companies.plan3.stat2.label': 'at every stage of the process',
    'landing.pricing.companies.plan3.cta': 'Request a demo',
    'landing.pricing.candidates.summary.label': 'Model for professionals',
    'landing.pricing.candidates.summary.title': 'Start free and unlock more momentum only when you want to accelerate visibility',
    'landing.pricing.candidates.summary.body':
      'The base should be accessible to everyone. If you want stronger feedback, better preparation and more visibility, you can level up without friction.',
    'landing.pricing.candidates.summary.chip1': 'Free profile to get started',
    'landing.pricing.candidates.summary.chip2': 'Optional visibility upgrades',
    'landing.pricing.candidates.summary.chip3': 'Real focus on interviews and feedback',
    'landing.pricing.candidates.summary.stat1.value': '$ 0 - $ 9',
    'landing.pricing.candidates.summary.stat1.label': 'suggested monthly investment range',
    'landing.pricing.candidates.summary.stat2.value': '24/7',
    'landing.pricing.candidates.summary.stat2.label': 'access to profile, alerts and tracking',
    'landing.pricing.candidates.plan1.badge': 'Free',
    'landing.pricing.candidates.plan1.name': 'Free',
    'landing.pricing.candidates.plan1.description': 'Build your profile, explore real openings and apply as many times as you want, at no cost.',
    'landing.pricing.candidates.plan1.price': '$ 0',
    'landing.pricing.candidates.plan1.cycle': '/ month',
    'landing.pricing.candidates.plan1.metric': 'Everything essential to start your job search: a visible profile, unlimited applications and alerts aligned to you.',
    'landing.pricing.candidates.plan1.helper': 'Ideal if you are starting your search or want to explore openings with no friction.',
    'landing.pricing.candidates.plan1.ideal': 'Start applying today',
    'landing.pricing.candidates.plan1.feature1': 'Professional profile visible to companies',
    'landing.pricing.candidates.plan1.feature2': 'Unlimited job applications',
    'landing.pricing.candidates.plan1.feature3': 'Job alerts aligned with your profile',
    'landing.pricing.candidates.plan1.feature4': 'Application status tracking',
    'landing.pricing.candidates.plan1.stat1.value': 'Unlimited',
    'landing.pricing.candidates.plan1.stat1.label': 'applications per month',
    'landing.pricing.candidates.plan1.stat2.value': '24/7',
    'landing.pricing.candidates.plan1.stat2.label': 'access to active openings',
    'landing.pricing.candidates.plan1.cta': 'Create my free profile',
    'landing.pricing.candidates.plan2.badge': 'Recommended',
    'landing.pricing.candidates.plan2.name': 'Premium',
    'landing.pricing.candidates.plan2.description': 'Everything in Free, plus artificial intelligence to power up your resume and get found by companies first.',
    'landing.pricing.candidates.plan2.price': '$ 9',
    'landing.pricing.candidates.plan2.cycle': '/ month',
    'landing.pricing.candidates.plan2.metric': 'Our AI works for you: improves your resume, highlights your strengths, alerts you to perfect matches and preps you for every interview.',
    'landing.pricing.candidates.plan2.helper': 'Perfect if you are already applying actively and want to speed up every stage.',
    'landing.pricing.candidates.plan2.ideal': 'Speed up your search with AI',
    'landing.pricing.candidates.plan2.feature1': 'Everything in Free',
    'landing.pricing.candidates.plan2.feature2': 'Instant CV Feedback: AI suggestions to optimize your resume',
    'landing.pricing.candidates.plan2.feature3': 'Strengths automatically highlighted to recruiters',
    'landing.pricing.candidates.plan2.feature4': 'Smart "Perfect Match" job alerts',
    'landing.pricing.candidates.plan2.feature5': 'Interview simulator with real role-specific questions',
    'landing.pricing.candidates.plan2.feature6': 'Featured profile: you appear first in search results',
    'landing.pricing.candidates.plan2.stat1.value': '3x',
    'landing.pricing.candidates.plan2.stat1.label': 'more visibility with recruiters',
    'landing.pricing.candidates.plan2.stat2.value': 'Top',
    'landing.pricing.candidates.plan2.stat2.label': 'priority on relevant results',
    'landing.pricing.candidates.plan2.cta': 'Activate Premium',
    'landing.pricing.reasons.title': 'Why thousands of users choose WeMatch',
    'landing.pricing.reasons.1.title': 'Zero fraud',
    'landing.pricing.reasons.1.body':
      'We automatically verify identity and technical skills to guarantee honesty.',
    'landing.pricing.reasons.2.title': '10x faster',
    'landing.pricing.reasons.2.body':
      'Cut hiring time from weeks down to just a couple of days with smart filtering.',
    'landing.pricing.reasons.3.title': 'No bias',
    'landing.pricing.reasons.3.body':
      'Our AI focuses on talent, removing unconscious bias from the initial screening.',
    'landing.pricing.faq.title': 'Frequently asked questions',
    'landing.pricing.faq.1.title': 'Can I cancel my subscription at any time?',
    'landing.pricing.faq.1.body':
      'Yes. There are no forced contracts or minimum commitments: cancel or change your plan anytime from your account, no penalties, no questions asked.',
    'landing.pricing.faq.2.title': 'What does the free trial for companies include?',
    'landing.pricing.faq.2.body':
      'Your 7-day free trial gives you full access to Premium features (resumes, evaluation results and comparative analytics) with no credit card required. When it ends, choose the plan that fits your team or stay on Free at no cost.',
    'landing.pricing.faq.3.title': 'How does AI Interview Prep work for candidates?',
    'landing.pricing.faq.3.body':
      'Our AI simulator asks you the most likely questions for the role you are applying to, evaluates your answers and gives you instant feedback so you arrive more prepared for the real interview. It is included in the Premium plan.',

    'landing.contact.eyebrow': 'Contact',
    'landing.contact.title': 'We are here to move your talent forward.',
    'landing.contact.body':
      'Tell us if you want to attract stronger talent, explore new opportunities or simply solve a question about WeMatch.',
    'landing.contact.form.title': 'Need help?',
    'landing.contact.form.subtitle':
      'Our team is ready to answer questions about the platform, pricing, integrations or support.',
    'landing.contact.form.schedule': 'Average response time: 24 hours',
    'landing.contact.form.name': 'Full name',
    'landing.contact.form.namePlaceholder': 'Type your name',
    'landing.contact.form.email': 'Email address',
    'landing.contact.form.emailPlaceholder': 'you@company.com',
    'landing.contact.form.company': 'Company',
    'landing.contact.form.companyPlaceholder': 'Company name',
    'landing.contact.form.topic': 'How can we help?',
    'landing.contact.form.topicPlaceholder': 'Select an option',
    'landing.contact.form.topic1': 'I want a demo',
    'landing.contact.form.topic2': 'Pricing',
    'landing.contact.form.topic3': 'Integrations',
    'landing.contact.form.topic4': 'General question',
    'landing.contact.form.message': 'Tell us more',
    'landing.contact.form.messagePlaceholder': 'Describe your request briefly',
    'landing.contact.form.note':
      'This form is visual only for now. We will connect real submission later.',
    'landing.contact.form.cta': 'Send message',
    'landing.contact.info.title': 'Contact information',
    'landing.contact.info.subtitle': 'You can also write to us or book a conversation with our team.',
    'landing.contact.info.emailTitle': 'Write to us',
    'landing.contact.info.emailValue': 'hello@wematch.team',
    'landing.contact.info.phoneTitle': 'Call us',
    'landing.contact.info.phoneValue': '+57 300 123 4566',
    'landing.contact.info.hoursTitle': 'Support hours',
    'landing.contact.info.hoursValue': '9:00 AM - 6:00 PM (COT)',
    'landing.contact.aside.title': 'We are ready to help',
    'landing.contact.aside.body':
      'Whether you want to hire better, improve your workflow or activate a demo, we can guide the next step.',

    'landing.about.eyebrow': 'About us',
    'landing.about.title': 'We design a clearer, fairer and more actionable way to hire.',
    'landing.about.body':
      'WeMatch exists to reduce noise, lower bias and help companies and candidates meet with stronger context, better evidence and better decisions.',
    'landing.about.hero.chip1': 'Evidence-based decisions',
    'landing.about.hero.chip2': 'Useful technology for talent',
    'landing.about.hero.chip3': 'More human experiences',
    'landing.about.hero.primary': 'See solutions for companies',
    'landing.about.hero.secondary': 'Create free profile',
    'landing.about.hero.boardLabel': 'Why we exist',
    'landing.about.hero.boardTitle': 'We turn recruiting friction into operational clarity',
    'landing.about.hero.boardBody':
      'We do not believe in noisy processes, opaque decisions or filters that punish strong talent. We build to improve decisions from the very beginning.',
    'landing.about.hero.stat1.value': '70%',
    'landing.about.hero.stat1.label': 'less operational time in the first filter',
    'landing.about.hero.stat2.value': 'AI + judgment',
    'landing.about.hero.stat2.label': 'automation with real context reading',
    'landing.about.hero.stat3.value': '360°',
    'landing.about.hero.stat3.label': 'shared visibility for team and candidate',
    'landing.about.hero.floating1': 'More traceable processes',
    'landing.about.hero.floating2': 'Less bias. More context.',
    'landing.about.metrics.1.value': '120k+',
    'landing.about.metrics.1': 'profiles reviewed with stronger context',
    'landing.about.metrics.2.value': '18+',
    'landing.about.metrics.2': 'countries connected through remote talent',
    'landing.about.metrics.3.value': '300+',
    'landing.about.metrics.3': 'teams operating with clearer flows',
    'landing.about.metrics.4.value': '24/7',
    'landing.about.metrics.4': 'platform ready to operate and evaluate',
    'landing.about.story.eyebrow': 'Our story',
    'landing.about.story.title': 'We are building a platform to improve how talent decisions get made',
    'landing.about.story.body':
      'The WeMatch story is not about creating one more ATS. It is about fixing a broken experience so hiring becomes more reliable, faster and far less arbitrary.',
    'landing.about.story.cardLabel': 'Our bet',
    'landing.about.story.cardTitle': 'Product with judgment, not empty automation',
    'landing.about.story.cardBody':
      'Every product layer is designed to connect speed with traceability, automation with explanation and efficiency with a fairer experience.',
    'landing.about.story.point1': 'Automate without losing the human reading of the process.',
    'landing.about.story.point2': 'Reduce friction for teams, recruiters and candidates.',
    'landing.about.story.point3': 'Turn complex signals into actionable decisions.',
    'landing.about.timeline.1.title': 'We identified a repeated problem',
    'landing.about.timeline.1.body':
      'We saw slow processes, opaque decisions and valuable talent left behind by poor or biased filters.',
    'landing.about.timeline.2.title': 'We designed the first product foundation',
    'landing.about.timeline.2.body':
      'We created an experience focused on ordering the pipeline, validating signals and giving context to every stage of the flow.',
    'landing.about.timeline.3.title': 'We tested and refined with real teams',
    'landing.about.timeline.3.body':
      'We turned operational feedback into stronger evaluation, tracking, visibility and support for faster decisions.',
    'landing.about.timeline.4.title': 'We evolved toward applied intelligence',
    'landing.about.timeline.4.body':
      'We integrated AI to prioritize better, explain better and support every flow without turning it into a black box.',
    'landing.about.principles.eyebrow': 'How we think',
    'landing.about.principles.title': 'The principles behind every product decision',
    'landing.about.principles.body':
      'These are not wall phrases. They are product, design and operational criteria we use to prioritize what truly creates value.',
    'landing.about.principles.1.title': 'Operational transparency',
    'landing.about.principles.1.body': 'Every step should explain what happened, why it happened and what comes next.',
    'landing.about.principles.2.title': 'Fairness with context',
    'landing.about.principles.2.body': 'We reduce bias by reading signals better, not by oversimplifying people.',
    'landing.about.principles.3.title': 'Speed with judgment',
    'landing.about.principles.3.body': 'Automation only matters if it helps people decide faster and better.',
    'landing.about.principles.4.title': 'Actionable technology',
    'landing.about.principles.4.body': 'AI should become clear recommendations, not unnecessary complexity.',
    'landing.about.principles.5.title': 'Consistent experience',
    'landing.about.principles.5.body': 'We care about every touchpoint so product, content and flow speak the same language.',
    'landing.about.principles.6.title': 'Verifiable value',
    'landing.about.principles.6.body': 'We want impact to show up in time, clarity, trust and closing capability.',
    'landing.about.impact.eyebrow': 'Real impact',
    'landing.about.impact.title': 'The value of WeMatch changes by audience, but it always chases the same outcome',
    'landing.about.impact.body':
      'For companies, that means clearer decisions and more scalable processes. For candidates, it means better visibility, stronger feedback and a fairer experience.',
    'landing.about.impact.companies.eyebrow': 'For companies',
    'landing.about.impact.companies.title': 'Teams that need better decisions without slowing the operation',
    'landing.about.impact.companies.body':
      'We combine evaluation, traceability and automation so every opening gets more context and less operational drag.',
    'landing.about.impact.companies.point1': 'Pipeline visibility without losing speed.',
    'landing.about.impact.companies.point2': 'Clearer comparisons to prioritize better.',
    'landing.about.impact.companies.point3': 'Less manual work, more focus on the final decision.',
    'landing.about.impact.companies.stat.value': '2x',
    'landing.about.impact.companies.stat.label': 'more clarity when reviewing profiles and stages',
    'landing.about.impact.companies.cta': 'See company flow',
    'landing.about.impact.candidates.eyebrow': 'For candidates',
    'landing.about.impact.candidates.title': 'Professionals who deserve to show up better and compete with more context',
    'landing.about.impact.candidates.body':
      'We help profiles read better, strengths gain more visibility and every application feel less blind.',
    'landing.about.impact.candidates.point1': 'Clearer feedback to improve profile and narrative.',
    'landing.about.impact.candidates.point2': 'Alerts and openings better aligned to real context.',
    'landing.about.impact.candidates.point3': 'More consistent preparation before interviews.',
    'landing.about.impact.candidates.stat.value': '24/7',
    'landing.about.impact.candidates.stat.label': 'continuous access to profile, alerts and tracking',
    'landing.about.impact.candidates.cta': 'Create profile in WeMatch',
    'landing.about.cta.eyebrow': 'What comes next',
    'landing.about.cta.title': 'We are building a more reliable way to connect talent and opportunity',
    'landing.about.cta.body':
      'If your team needs more clarity to hire or if you want to present your professional profile better, WeMatch is designed to support that next step.',
    'landing.about.cta.button': 'Talk to the team',

    'landing.privacy.title': 'Privacy Policy',
    'landing.privacy.updatedAt': 'Last updated: May 28, 2026',
    'landing.privacy.intro':
      'This is placeholder content and will be replaced by the final legal copy before publication.',
    'landing.privacy.contactLabel': 'Contact channel',
    'landing.privacy.contactValue': 'privacy@wematch.team',
    'landing.privacy.section1.title': 'Information we collect',
    'landing.privacy.section1.body':
      'We may collect identity data, contact information, professional information and product usage activity.',
    'landing.privacy.section2.title': 'How we use your data',
    'landing.privacy.section2.body':
      'We use this information to operate the platform, improve the experience and keep hiring workflows secure.',
    'landing.privacy.section2.item1': 'Create and manage accounts',
    'landing.privacy.section2.item2': 'Improve recommendations and application flows',
    'landing.privacy.section2.item3': 'Detect fraud and protect the platform',
    'landing.privacy.section3.title': 'Legal basis and consent',
    'landing.privacy.section3.body':
      'We process data based on consent, contract performance and legitimate operational needs for the service.',
    'landing.privacy.section4.title': 'Data retention',
    'landing.privacy.section4.body':
      'We retain information for as long as necessary to provide the service, meet legal obligations and resolve reasonable disputes.',
    'landing.privacy.section5.title': 'Sharing information',
    'landing.privacy.section5.body':
      'We may share information with operational providers and technology partners under confidentiality and security agreements.',
    'landing.privacy.section6.title': 'Your rights',
    'landing.privacy.section6.body':
      'You may request access, updates, correction or deletion of personal data by contacting our privacy channel.',

    'landing.terms.title': 'Terms and Conditions of Use',
    'landing.terms.updatedAt': 'Last updated: May 28, 2026',
    'landing.terms.intro':
      'This document is temporary and acts as placeholder content while the legal team prepares the final version.',
    'landing.terms.contactLabel': 'Email',
    'landing.terms.contactValue': 'info@wematch.team',
    'landing.terms.section1.title': 'Acceptance of the terms',
    'landing.terms.section1.body':
      'By accessing and using the platform you agree to be bound by these terms and conditions of use.',
    'landing.terms.section2.title': 'Service description',
    'landing.terms.section2.body':
      'WeMatch provides tools to connect companies and candidates, publish openings and support early stage evaluation.',
    'landing.terms.section3.title': 'Account registration',
    'landing.terms.section3.body':
      'To use certain features you may need to create an account. You agree to:',
    'landing.terms.section3.item1': 'Provide accurate and updated information',
    'landing.terms.section3.item2': 'Keep your credentials confidential',
    'landing.terms.section3.item3': 'Notify us about unauthorized account use',
    'landing.terms.section3.item4': 'Assume responsibility for recorded activity',
    'landing.terms.section4.title': 'Acceptable use',
    'landing.terms.section4.body':
      'When using WeMatch, you agree not to perform actions that affect the integrity of the service or other parties.',
    'landing.terms.section4.item1': 'Publish false or misleading content',
    'landing.terms.section4.item2': 'Violate third party rights',
    'landing.terms.section4.item3': 'Attempt unauthorized system access',
    'landing.terms.section4.item4': 'Interfere with normal platform operations',
    'landing.terms.section5.title': 'Intellectual property',
    'landing.terms.section5.body':
      'Service content, designs and components are owned by WeMatch or its licensors and cannot be reused without permission.',
    'landing.terms.section6.title': 'Privacy and data protection',
    'landing.terms.section6.body':
      'The use of personal data is governed by our Privacy Policy and by the rules applicable to the service.',
    'landing.terms.section7.title': 'Limitation of liability',
    'landing.terms.section7.body':
      'WeMatch will not be liable for indirect, incidental or consequential damages arising from use of the service.',
    'landing.terms.section8.title': 'Service and terms updates',
    'landing.terms.section8.body':
      'We may update these terms or adjust service functionality. Continued use will imply acceptance of the changes.',
  },
};
